import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { micromark } from "micromark";

interface Props {
  /** markdown input source */
  source: string;
  /** what component to wrap source in */
  component?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMarkdown',
  props: {
    source: null,
    component: { default: "div" }
  },
  setup(__props: any) {

const props = __props as { source: string, component: string }



/** html converted from markdown source code */
const html = computed(() =>
  micromark(props.source || "")
    .replaceAll("<p>", "")
    .replaceAll("</p>", "")
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.component), { innerHTML: _unref(html) }, null, 8, ["innerHTML"]))
}
}

})